import { useContext, useState } from "react";

import FolderCopy from "@mui/icons-material/FolderCopy";
import FolderOutlined from "@mui/icons-material/FolderOutlined";
import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { AppContext } from "App";
import { formatPersonName } from "utility/formatters";

export default function PortfolioItem({ producer, userGrant, onClick }) {
  const { globalState, globalDispatch } = useContext(AppContext);

  const [drafts, setDrafts] = useState([]);

  const [expanded, setExpanded] = useState(
    globalState.producer_token == (producer?.producer_token || userGrant?.producer_token)
  );

  const handleItemOnClick = async () => {
    onClick &&
      onClick({
        producer_token: producer?.producer_token || userGrant?.producer_token,
        agent_token: globalState?.agent_token,
      });
  };

  return (
    <>
      <ListItem>
        <ListItemButton
          onClick={handleItemOnClick}
          sx={(theme) => ({
            p: 2,
            ...(globalState.producer_token === (producer?.producer_token || userGrant?.producer_token) && {
              backgroundImage: `linear-gradient(90deg, ${theme.palette.colors.brandLightGreen} 0%, ${theme.palette.colors.brandMediumOrange} 100%)`,
            }),
          })}
        >
          <ListItemIcon>
            <FolderCopy />
          </ListItemIcon>
          <ListItemText
            primary={
              formatPersonName(producer) || producer?.business_name || userGrant?.producer_description
            }
          />
          {/* {expanded ? <ExpandLessOutlined /> : <ExpandMoreOutlined />} */}
        </ListItemButton>
      </ListItem>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {drafts.map((currentDraft, index) => (
            <ListItemButton
              onClick={handleItemOnClick}
              key={index}
              sx={(theme) => ({
                p: 2,
                ml: 4,
                ...(globalState.producer_token === (producer?.producer_token || userGrant?.producer_token) && {
                  backgroundImage: `linear-gradient(90deg, ${theme.palette.colors.brandLightGreen} 0%, ${theme.palette.colors.brandMediumOrange} 100%)`,
                }),
              })}
            >
              <ListItemIcon>
                <FolderOutlined />
              </ListItemIcon>
              <ListItemText primary={currentDraft.name} />
            </ListItemButton>
          ))}

          {/* <ListItemButton sx={{ ml: 4, p: 2 }} onClick={addNewLine}>
                    <ListItemIcon>
                        <CreateNewFolderOutlined />
                    </ListItemIcon>
                    <ListItemText primary='(New)' />
                </ListItemButton> */}
        </List>
      </Collapse>
    </>
  );
}
